<template>
    <div
        class="fixed top-0 left-0 z-50 flex flex-wrap content-center w-full h-full p-2 bg-transparent_white sm:p-4"
        :class="{ 'modal-overlay-wide': wide }"
        style="z-index:999999;"
    >
        <div
            class="relative mx-auto bg-white border-2 rounded-2xl border-light_green modal-cont"
            :class="wide ? 'w-11/12 md:w-10/12 xl:w-8/12 modal-cont-wide' : 'w-10/12 md:w-2/6'"
        >
            <button
                type="button"
                class="absolute z-10 flex items-center justify-center w-10 h-10 text-xl font-bold bg-white rounded-full shadow-md cursor-pointer top-3 right-3 text-enriqueto_green"
                aria-label="Cerrar"
                @click="hideModal"
            >
                ×
            </button>
            <div class="px-8 py-4 pt-10 pr-16 rounded-t-2xl bg-enriqueto_yellow">
                <h2 class="text-xl text-enriqueto_green">{{title}}</h2>
            </div>
            <div
                class="h-full px-4 py-5 overflow-y-scroll rounded-b-2xl sm:px-8 sm:py-6 scrollbar-hidden modal-slot-cont"
                :class="{ 'modal-slot-cont-wide': wide }"
            >
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from '@vue/reactivity'

export default {
    props: ['title', 'wide'],
    setup(props,{emit}){
        const show_modal = ref(false)
        
        const hideModal = ()=>{
            show_modal.value=false
            emit('update:modelValue', show_modal.value);
            console.log(show_modal.value);
        }
        return{
            hideModal,
            show_modal
        }
    }
}
</script>

<style>
    .modal-cont{
        max-height: 550px;
        
    }
    .modal-slot-cont{
        max-height: 450px;
    }

    .modal-cont-wide{
        max-height: calc(100vh - 8rem);
    }

    .modal-slot-cont-wide{
        max-height: calc(100vh - 8rem - 92px);
    }

    .modal-overlay-wide{
        align-content: flex-start;
        padding-top: 7rem;
        padding-bottom: 1rem;
    }

    @media (max-width: 768px) {
        .modal-cont{
            max-height: 70%;
        
        }
        .modal-slot-cont{
            max-height: 82%;
        }

        .modal-cont-wide{
            max-height: calc(100vh - 7rem);
        }

        .modal-slot-cont-wide{
            max-height: calc(100vh - 7rem - 86px);
        }

        .modal-overlay-wide{
            padding-top: 6rem;
            padding-bottom: 1rem;
        }
    }



</style>
